"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../utils/use-isomorphic-layout-effect"));
var _measureHiddenNode2 = _interopRequireDefault(require("../../utils/measure-hidden-node"));
var _useAnimationState = require("../../utils/use-animation-state");
require("./expander.css");
var _excluded = ["children", "isExpanded", "expandEffect"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var duration = exports.duration = 300;

/**
 * `Expander` animates the height of its children to an expanded
 * or collapsed state based on the value of the `isExpanded` prop.
 *
 * There are two effects for showing/hiding content as the Expander animates,
 * which are passed as props:
 * - `reveal` (default) -> Content is revealed top-down (ie. top is seen first)
 * - `pushdown` -> Content is pushed down into view (ie. bottom is seen first)
 *
 * Note: The `SimpleExpander` (see below) builds on top of `Expander`;
 * it provides out of the box logic for toggling the expanded state and handles
 * accessibility concerns.
 */
var Expander = function Expander(_ref) {
  var children = _ref.children,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$expandEffect = _ref.expandEffect,
    expandEffect = _ref$expandEffect === void 0 ? 'reveal' : _ref$expandEffect,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = _react["default"].useRef();
  var contentRef = _react["default"].useRef();
  var animationState = (0, _useAnimationState.useAnimationState)(isExpanded, duration);
  var _useState = (0, _react.useState)(isExpanded ? 'auto' : '0px'),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    prevAnimationState = _useState4[0],
    setPrevAnimationState = _useState4[1];
  var setHeightToContentHeight = function setHeightToContentHeight() {
    var _measureHiddenNode = (0, _measureHiddenNode2["default"])({
        node: contentRef.current,
        parentNode: containerRef.current
      }),
      contentHeight = _measureHiddenNode.height;
    setHeight("".concat(contentHeight, "px"));
  };
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    if (animationState === _useAnimationState.states.opening) {
      setHeightToContentHeight();
    }
    if (animationState === _useAnimationState.states.open) {
      // setting to auto helps to ensure that the "final" height is correct,
      // and allow changes in viewport to effect reflow normally
      setHeight('auto');
    }
    if (animationState === _useAnimationState.states.closing) {
      // can't change straight from 'auto' to zero, because transition won't work.
      // So we first set the content height...
      setHeightToContentHeight();
    }
    // ... then re-set the height on the next state change
    if (prevAnimationState === _useAnimationState.states.closing) {
      setHeight('0px');
    }
    if (animationState !== prevAnimationState) {
      // Because there are two height changes needed to animate closed, but only one
      // animation state change, we track the previous animation state
      // to give us the extra render (which allows us to set the height twice).
      setPrevAnimationState(animationState);
    }
  }, [animationState, prevAnimationState]);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('sb-expander', {
      relative: expandEffect === 'pushdown',
      'sb-expander_overflow': animationState !== _useAnimationState.states.open
    }),
    ref: containerRef,
    style: {
      height: height
    }
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: animationState === _useAnimationState.states.closed,
      // once pushdown type is open, let it not be absolutely positioned, so
      // auto height works
      'sb-expander__pushdownContent': expandEffect === 'pushdown' && animationState !== _useAnimationState.states.open
    }),
    ref: contentRef
  }, children));
};
Expander.displayName = 'Expander';
Expander.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * How the content appears as the expander animates open
   */
  expandEffect: _propTypes["default"].oneOf(['reveal', 'pushdown']),
  isExpanded: _propTypes["default"].bool.isRequired
} : {};
var _default = exports["default"] = Expander;